module.exports = __webpack_public_path__ + "static/img/9.b36f53d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/zh/9.png
// module id = UJCg
// module chunks = 0